import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

interface IHttpResponse {
  error_code: number;
  error_msg: string;
  data: any;
}

interface IGetDetails {
  page: number;
  page_size: number;
}

const INVITE_OVERVIEW_API = "/api/member/friend_invitation/processing_overview";
const INVITE_CASHBACK_RATE_API = "/api/member/friend_invitation/cashback_rate";
const INVITE_DETAIL_API =
  "/api/member/friend_invitation/processing_detail_list";
const INVITE_REQUEST_QR_CODE_API =
  "/api/member/friend_invitation/request_qr_code";
const INVITE_TEXT_API = "/api/member/friend_invitation/v2_invite_text";
const INVITE_QR_CODE_API = "/api/member/friend_invitation/qr_code";

@Injectable({
  providedIn: "root",
})
export class InviteService {
  constructor(private http: HttpClient) {}

  getInviteOverview() {
    return this.http.get(INVITE_OVERVIEW_API) as Observable<IHttpResponse>;
  }

  getCashbackRate() {
    return this.http.get(INVITE_CASHBACK_RATE_API) as Observable<IHttpResponse>;
  }

  getInviteDetail(params: IGetDetails) {
    const query = new HttpParams()
      .append("page", `${params.page}`)
      .append("page_size", `${params.page_size}`);
    return this.http.get(INVITE_DETAIL_API, { params: query }) as Observable<
      IHttpResponse
    >;
  }

  getWithdrawalCode() {
    return this.http.get(INVITE_REQUEST_QR_CODE_API) as Observable<
      IHttpResponse
    >;
  }

  getInviteLinkText() {
    return this.http.get(INVITE_TEXT_API) as Observable<IHttpResponse>;
  }

  getInviteCode() {
    return this.http.get(INVITE_QR_CODE_API) as Observable<IHttpResponse>;
  }
}
